import React from 'react';

import Hotspots from 'components/Hotspots/Hotspots';
import HotspotA from 'components/Hotspots/Landing/HotspotA/HotspotA';
import HotspotB from 'components/Hotspots/Landing/HotspotB/HotspotB';
import HotspotC from 'components/Hotspots/Landing/HotspotC/HotspotC';
import HotspotD from 'components/Hotspots/Landing/HotspotD/HotspotD';

import HotspotSelfcareA from 'components/Hotspots/Selfcare/HotspotA/HotspotSelfcareA';
import HotspotSelfcareB from 'components/Hotspots/Selfcare/HotspotB/HotspotSelfcareB';

/* eslint-disable react/prop-types */

export const hotspotALayout = ({ version = 1 }) => {
  const hotspotProps = {
    title: 'Risus viverra tellus cupidata dipiscing.',
    description: version === 1
      ? 'Consectetur adipiscing elit, sed do incididunt ut labore et dolore magna aliqua.'
      : null
    ,
    listItems: version === 2
      ? ['consectetur adipiscing elit', 'consectetur adipiscing elit', 'consectetur adipiscing elit']
      : null
    ,
    link: 'only text 16px',
    withIllustration: {
      name: 'thought-leadership-article-on-ddos',
      size: '240'
    }
  };

  return (
    <Hotspots>
      <HotspotA {...hotspotProps} />
      <HotspotA {...hotspotProps} />
    </Hotspots>
  );
};

export const hotspotBLayout = ({ version = 1 }) => {
  const hotspotProps = {
    title: version === 1
      ? 'Risus viverra tellus cupidatat adipiscing.'
      : 'Risus viverra iscing at in tellus integer ecupidatatd scelerisque.'
    ,
    description: version === 1
      ? 'Consectetur adipiscing elit, sed do incididunt ut labore et dolore magna do incididunt ut labore et daliqua.'
      : null
    ,
    link: 'only text 16px'
  };

  return (
    <Hotspots>
      <HotspotB {...hotspotProps} />
      <HotspotB {...hotspotProps} />
    </Hotspots>
  );
};

export const hotspotCLayout = ({ version = 1 }) => {
  const hotspotProps = {
    colorScheme: version === 1
      ? 'lb03'
      : 'db02'
    ,
    highlighted: version === 1
      ? 'Risus viverra'
      : 'Risus viat adicing at'
    ,
    title: version === 1
      ? 'ascing at telus consequat.'
      : 'telus intest celeque.'
    ,
    description: version === 1
      ? 'Consectetur adipiscing elit sed do incididunt ut labore et dolore magna aliqua viverra.'
      : null
    ,
    link: 'only text 20px',
    withIllustration: version === 1
      ? {
          name: 'thought-leadership-article-on-ddos',
          size: '240'
        }
      : null
    ,
    imageUrl: version === 2
      ? 'path/to/image'
      : null 
  };

  return (
    <Hotspots>
      <HotspotC {...hotspotProps} />
      <HotspotC {...hotspotProps} />
    </Hotspots>
  );
};

export const hotspotDLayout = () => (
  <Hotspots fullwidth>
    <HotspotD
      highlighted="Risus viat adicing at"
      title="telus intest celeque."
      description="Consectetur adipiscing elit sed do incididunt ut labore et dolore magna aliqua viverra."
      link="only text 20px"
      imageUrl="path/to/image"
    />
  </Hotspots>
);

export const hotspotSelfcareALayout = () => (
  <div style={{ maxWidth: '430px' }}>
    <Hotspots selfcare>
      <HotspotSelfcareA
        label="Lorem ipsum dolor"
        highlighted="Lorem ipsum dolor"
        title="Lorem ipsum."
        description="Risus viverra adipiscing at in tellus integer scelerisque."
        link="only text 14px"
        imageUrl="path/to/image"
      />
    </Hotspots>
  </div>
);

export const hotspotSelfcareBLayout = ({ version = 1 }) => {
  const versionProp = version === 1
    ? { colorScheme: 'db01', button: 'Lorem Ipsum' }
    : { colorScheme: 'lb01', link: 'only text 14px' }
  ;

  return (
    <Hotspots selfcare>
      <HotspotSelfcareB
        highlighted="Lorem ipsum"
        title="Risus viverra."
        description="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum ut nibh viverra."
        withIllustration={{
          name: 'thought-leadership-article-on-ddos',
          size: '180'
        }}
        {...versionProp}
      />
    </Hotspots>
  );
};

/* eslint-enable react/prop-types */



// WEBPACK FOOTER //
// ./src/containers/components/Hotspots/constants/hotspotsLayouts.js